import { TimeZone } from './models/time-zones.models';

export enum TimeZones {
  UsaEasternTimeKey = 'America/New_York',
  UsaCentralTimeKey = 'America/Chicago',
  UsaMountainTimeKey = 'America/Denver',
  UsaMountainStandardTimeKey = 'America/Phoenix',
  UsaPacificTimeKey = 'America/Los_Angeles',
  UsaAlaskanTimeKey = 'America/Anchorage',
  UsaHawaiianStandardTimeKey = 'Pacific/Honolulu',
  AmericasSurinameTimeKey = 'America/Paramaribo',
  AsiaJordanTimeKey = 'Asia/Amman',
  EuropeCentralTimeKey = 'Europe/Berlin',
  EuropeGreenwichTimeKey = 'Europe/London',
  AustraliaEasternStandardTimeKey = 'Australia/Queensland',
  AustraliaCentralStandardTimeKey = 'Australia/Darwin',
  PeruStandardTimeKey = 'America/Lima',
  ChileStandardTimeKey = 'America/Santiago',
  AtlanticStandardTimeKey = 'America/Tortola',
  MexicoStandardTimeKey = 'America/Mexico_City',
}

export const TIME_ZONES = [
  new TimeZone('US Eastern Time', 'USA / Eastern  Time', TimeZones.UsaEasternTimeKey),
  new TimeZone('US Central Time', 'USA / Central Time', TimeZones.UsaCentralTimeKey),
  new TimeZone('US Mountain Time', 'USA / Mountain Time', TimeZones.UsaMountainTimeKey),
  new TimeZone('US Mountain Standard Time', 'USA / Mountain Standard Time (Arizona)', TimeZones.UsaMountainStandardTimeKey),
  new TimeZone('US Pacific Time', 'USA / Pacific Time', TimeZones.UsaPacificTimeKey),
  new TimeZone('US Alaskan Time', 'USA / Alaskan Time', TimeZones.UsaAlaskanTimeKey),
  new TimeZone('US Hawaiian Standard Time', 'USA / Hawaiian Standard Time', TimeZones.UsaHawaiianStandardTimeKey),
  new TimeZone('Americas Suriname Time', 'Americas / Suriname', TimeZones.AmericasSurinameTimeKey),
  new TimeZone('Asia Jordan Time', 'Asia / Jordan Time', TimeZones.AsiaJordanTimeKey),
  new TimeZone('Europe Central Time', 'Europe / Central Europe Time', TimeZones.EuropeCentralTimeKey),
  new TimeZone('Europe Greenwich Time', 'Europe / Greenwich Time', TimeZones.EuropeGreenwichTimeKey),
  new TimeZone('Australia Eastern Standard Time', 'Australia / Eastern Standard Time', TimeZones.AustraliaEasternStandardTimeKey),
  new TimeZone('Australia Central Standard Time', 'Australia / Central Standard Time', TimeZones.AustraliaCentralStandardTimeKey),
  new TimeZone('Peru Standard Time', 'Peru / Peru Standard Time', TimeZones.PeruStandardTimeKey),
  new TimeZone('Chile Standard Time', 'Chile / Chile Standard Time', TimeZones.ChileStandardTimeKey),
  new TimeZone('Americas British Virigin Islands', 'Americas / British Virgin Islands', TimeZones.AtlanticStandardTimeKey),
  new TimeZone('Mexico Central Time', 'Mexico / Central Time', TimeZones.MexicoStandardTimeKey),
];
